<div class="administration-page">
  <div class="card">
    <div class="page-header">
      <div class="page-header-text">
        <h2 class="page-title">
          {{ "administration.title" | translate }}
        </h2>
      </div>

      <button
        *ngIf="canCreateOrganization"
        class="button-blue"
        type="button"
        routerLink="/administration/add-organization"
        routerLinkActive="active"
      >
        <lucide-angular name="plus" [size]="18"></lucide-angular>

        {{ "administration.addOrganization.button" | translate }}
      </button>

      <app-invite-member-button
        *ngIf="!canViewAllOrganizations && canInviteMember"
        (memberInvited)="loadOrganizationDetails()"
      ></app-invite-member-button>
    </div>
  </div>

  <!-- ADMIN: the current organization's own details -->
  <app-organization-details
    *ngIf="!canViewAllOrganizations"
    [details]="organizationDetails"
    (invitationChanged)="loadOrganizationDetails()"
    (memberChanged)="loadOrganizationDetails()"
  ></app-organization-details>

  <!-- SUPER ADMIN: the list of every organization -->
  <div class="card" *ngIf="canViewAllOrganizations">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>{{ "common.name" | translate }}</th>
            <th>{{ "administration.organizationsList.memberCount" | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let overview of organizations"
            [class.clickable-row]="canViewOrganizationDetails"
            [class.current-row]="isCurrentOrganization(overview)"
            [attr.aria-current]="isCurrentOrganization(overview) ? 'true' : null"
            (click)="goToOrganization(overview.organization.id)"
          >
            <td>
              <div class="organization-name-cell">
                <span>{{ overview.organization.name }}</span>
                <span *ngIf="isCurrentOrganization(overview)" class="badge badge-current">
                  {{ "administration.organizationsList.current" | translate }}
                </span>
              </div>
            </td>
            <td>{{ overview.userCount }}</td>
          </tr>

          <tr *ngIf="organizations.length === 0">
            <td colspan="2" class="empty-row">{{ "administration.organizationsList.noData" | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
